import {Endpoints} from '../../../../../../../../../globals/api/endpoints';

export class CustomIconsEndpoints extends Endpoints {
  public static readonly ICONS = CustomIconsEndpoints.VIEWER + '/custom-icon';

  public static readonly ICON = CustomIconsEndpoints.ICONS + '/' + CustomIconsEndpoints.ICON_ID;
}
